import React from 'react';

import { categories } from 'util/appConstants';
import { useAppContext, useFreecodeContext } from 'hooks/useContext';
import { tabLabels, identifiers, buttonIds } from '../../FreecodePage/FreecodeLayoutConstants';
import FreecodeTabSelector from 'components/FreecodeTabSelector/FreecodeTabSelector';
import { RectangleButton } from 'components/Button/rectangleButton';
import { OptionContainer } from 'components/FreecodeTabSelector/styles';
import { Checkbox } from 'components/Checkbox/Checkbox';
import Console from './Console';
import Score from './Score';

export default function FreecodeConsoleAndScore() {
  const { isDarkMode } = useAppContext();
  const { test, isCreator, submit } = useFreecodeContext();

  // TODO implement run options
  const runCode = () => alert('Run not implemented');

  const getHeaderOptions = () => (
    <OptionContainer>
      {isCreator && test.category !== categories.EXERCISE.category && (
        <Checkbox
          isDarkMode={isDarkMode}
          checked={false}
          label="Run Hidden Levels"
          onChange={() => alert('not implemented')}
        />
      )}
      {isCreator && (
        <Checkbox
          isDarkMode={isDarkMode}
          checked={false}
          label="Save On Run"
          onChange={() => alert('not implemented')}
        />
      )}
      <RectangleButton id={buttonIds.runButton} small onClick={runCode}>
        Run Code
      </RectangleButton>
      {submit && (
        <RectangleButton small onClick={submit}>
          Submit
        </RectangleButton>
      )}
    </OptionContainer>
  );

  return (
    <FreecodeTabSelector
      items={[
        {
          icon: tabLabels[identifiers.console].icon,
          label: tabLabels[identifiers.console].label,
          tabId: tabLabels[identifiers.console].tabId,
          component: <Console />,
        },
        {
          icon: tabLabels[identifiers.score].icon,
          label: tabLabels[identifiers.score].label,
          tabId: tabLabels[identifiers.score].tabId,
          component: <Score />,
        },
      ]}
      headerComponents={getHeaderOptions()}
    />
  );
}
